import type { ElevarEvent } from 'types'
import { segment } from './segment'
import { fullstory } from './fullstory'
import { productAddedTransformer } from './events/product-added'
import { productRemovedTransformer } from './events/product-removed'

export const transformEvent = (item: ElevarEvent): ElevarEvent => {
  switch (item.event) {
    case 'dl_add_to_cart':
      productAddedTransformer(item).catch(console.error)
      break
    case 'dl_remove_from_cart':
      productRemovedTransformer(item).catch(console.error)
      break
    case 'dl_view_cart':
      fullstory.event('Cart Viewed', {
        cart_total: item.cart_total || 0,
        currency: item.ecommerce?.currencyCode || 'USD',
        item_count: item.ecommerce?.impressions?.length || 0,
        variant_ids:
          item.ecommerce?.impressions?.map((p) => p.variant_id).join(',') || '',
      })
      break
    case 'dl_select_item': {
      const product = item.ecommerce?.click?.products?.[0]
      if (product) {
        fullstory.event('Product Clicked', {
          product_id: product.product_id || '',
          product_name: product.name || '',
          variant: product.variant || '',
          price: Number.parseFloat(product.price) || 0,
          currency: item.ecommerce?.currencyCode || 'USD',
          list: product.list || '',
          position: product.position || 0,
        })
      }
      break
    }
  }

  return item
}

export const initializeEventTransformers = (): void => {
  segment.ready(() => {
    window.ElevarTransformFn = transformEvent
  })
}
